





import { Vue, Component, Prop } from "@/shared/vuepack";

@Component
export default class ValueBadge extends Vue {

  @Prop({required: true})
  value: string;

  @Prop()
  cssClass: string;
}

